import { useData } from "@/renderer/useData";
import { DataBlog } from "../index/+onBeforePrerenderStart";
import PopularBlogs from "@/components/sections/popular-blogs";
import { Contact } from "@/components/sections";
import { Components, TinaMarkdown } from "tinacms/dist/rich-text";

export { Page };

const components: Components<{
  content: {
    children: JSX.Element;
  };
}> = {
  p(props) {
    return <p className="text-gray-500 py-4">{props?.children}</p>;
  },
  block_quote(props) {
    return <blockquote className="text-gray-500">{props?.children}</blockquote>;
  },
  h1(props) {
    return (
      <h1 className="text-3xl my-6 font-bold text-gray-900 sm:text-4xl">
        {props?.children}
      </h1>
    );
  },
  h2(props) {
    return (
      <h2 className="text-2xl my-6 font-bold text-gray-900 sm:text-3xl">
        {props?.children}
      </h2>
    );
  },
  hr(props) {
    return <hr className="border-gray-200" />;
  },
  content: (props) => {
    return <div className="text-gray-500">{props?.children}</div>;
  },
  a: (props) => {
    return (
      <a
        className="text-blue-500 hover:text-blue-600 underline"
        href={props?.url}
        target="_blank"
      >
        {props?.children}
      </a>
    );
  },
  ul: (props) => {
    return <ul className="list-disc">{props?.children}</ul>;
  },
  li: (props) => {
    return <li className="text-gray-500">{props?.children}</li>;
  },
};

function Page() {
  const { post, popularPosts } = useData<DataBlog>();
  return (
    <>
      {post.tag && post.tag !== "" ? (
        <span className="text-xl px-3 py-1 border border-[#5263ff] rounded-3xl w-fit self-center uppercase">
          {post.tag}
        </span>
      ) : null}
      <h1 className="text-3xl m-8 text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl uppercase">
        {post.title}
      </h1>
      {post.thumbnail && post.thumbnail !== "" ? (
        <div className="relative w-full min-h-[550px] flex justify-center items-center text-white text-center">
          <img
            alt={post.title}
            src={post.thumbnail}
            className="md:rounded-3xl z-0 object-cover fill-img"
          />
        </div>
      ) : null}
      <div className="py-16 overflow-hidden text-black">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto">
            <TinaMarkdown content={post.body} components={components} />
          </div>
        </div>
      </div>
      <div className="px-4 mb-12">
        <PopularBlogs posts={popularPosts} />
      </div>
      <Contact />
    </>
  );
}
